module.exports = __webpack_public_path__ + "img/审核失败.559ae1aa.png";